export default "__VITE_ASSET__CCBV0kkS__"